import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-bootstrap/esm/Button.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/(mkgeu)/mkg-add-ons/AddOnOverzicht.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/(mkgeu)/mkg-add-ons/MkgAddOns.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["RightMouseClickMenu"] */ "/app/src/components/RightMouseClickMenu/RightMouseClickMenu.jsx");
